import { combineSlices, configureStore } from '@reduxjs/toolkit'
import { assetsSlice } from './assets'
import { configSlice } from './config'
import { languagesSlice } from './languages'
import { loadingSlice } from './loading'
import { metaSlice } from './meta'
import { tempSlice } from './temp'

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface LoadedSlices {}

const slices = [
	configSlice,
	loadingSlice,
	assetsSlice,
	metaSlice,
	languagesSlice,
	tempSlice,
] as const
export const reducer = combineSlices(
	...slices,
).withLazyLoadedSlices<LoadedSlices>()

export type Store = ReturnType<typeof createStore>
export type State = ReturnType<typeof reducer>

export function createStore(preloadedState?: State) {
	return configureStore({
		reducer,
		preloadedState,
		devTools: { name: 'shiva' },
	})
}
